import {TemplateTypes} from '../EmailEditor';
import {QuoteTemplateParams} from '../templates/quoteTemplateParams';

const TERM_NON_BLEND_READ_QUOTE_URL = '5beb235dbbc744f38cb1ef47132ce25a';
const IUL_NON_BLEND_READ_QUOTE_URL = '6e5ef14dda094378abb6f79279edd611';
const GUL_NON_BLEND_READ_QUOTE_URL = '7fcbd31695294e158641e575a185a36d';
const TERM_GUL_BLEND_READ_QUOTE_URL = '9f443927d2f94125b64b56bb7263f7a8';
const TERM_IUL_BLEND_READ_QUOTE_URL = 'f349f86723b64364b72f529b7e26b03c';

export const getHowToReadQuotesVideo = (param: QuoteTemplateParams[] | QuoteTemplateParams) => {
    let type = null;
    let url = null;

    if (Array.isArray(param)) {
        const isIUL = (param as QuoteTemplateParams[]).every((p) => p.product_type === 'IUL');
        const isGUL = (param as QuoteTemplateParams[]).every((p) => p.product_type === 'GUL');

        if (isIUL) {
            type = TemplateTypes.quoteIulNonblend;
        }

        if (isGUL) {
            type = TemplateTypes.quoteGulNonblend;
        }
    } else {
        type = (param as QuoteTemplateParams).template_type;
    }

    if (type === TemplateTypes.quoteTermNonblend) {
        url = TERM_NON_BLEND_READ_QUOTE_URL;
    }
    if (type === TemplateTypes.quoteIulNonblend) {
        url = IUL_NON_BLEND_READ_QUOTE_URL;
    }
    if (type === TemplateTypes.quoteGulNonblend) {
        url = GUL_NON_BLEND_READ_QUOTE_URL;
    }
    if (type === TemplateTypes.quoteGULTermBlend) {
        url = TERM_GUL_BLEND_READ_QUOTE_URL;
    }
    if (type === TemplateTypes.quoteIULTermBlend) {
        url = TERM_IUL_BLEND_READ_QUOTE_URL;
    }

    if (url) {
        return `<p><a href="https://www.loom.com/share/${url}" target="_blank"> <img style="max-width: 300px;" src="https://cdn.loom.com/sessions/thumbnails/${url}-with-play.gif" /></a></p>`;
    } else {
        return '';
    }
};
